import React from 'react'
import Forms from '../../../components/common/Form'
import formConfig from "../../../formJsonData/Purchase/AMCMaster/AMCForm.json";
import searchConfigJson from "../../../formJsonData/LMS/searchFilterFields.json";
const AMCForm = () => {
  return (
    <div>
      
      <Forms formConfig={formConfig} searchConfigJson={searchConfigJson.calibration}/>
    </div>
  )
}

export default AMCForm